import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { Card } from 'react-bootstrap';
import { currency } from 'helpers/utils';
import Input from 'components/common/Input';
import bg3 from 'assets/img/icons/spot-illustrations/corner-3.png';
import Background from 'components/common/Background';

const Financing = ({ watch, register, errors, setValue, verifyFields }) => {
 const [config, setConfig] = useState({});

 const onFocus = ({ target }) => {
  target.select();
  verifyFields({ keyCode: 'focus', target });
 };

 const onBlur = e => verifyFields(e);

 const onKeyDown = key => (/13|27/.test(key.keyCode) ? verifyFields(key) : '');

 const onChange = ({ target: { name, value } }) => setValue(name, currency(value, true));

 useEffect(() => {
  setConfig(watch('defaultValues'));
 }, [watch('defaultValues')]);

 return (
  <Card className="overflow-hidden" style={{ minWidth: '12rem' }}>
   <Background image={bg3} className="bg-card" />
   <Card.Body>
    <Flex alignItems="center" wrap="wrap" className="fs--2 mb-2">
     <div className="flex-grow-1">
      <h5 className="text-success">Financiacion</h5>
     </div>
     <Card className="me-2" style={{ maxWidth: '60px' }}>
      <Input
       type="simple-text"
       errors={errors}
       label="Cuotas"
       name="financings"
       placeholder="Num"
       formControlProps={{
        ...register('financings', {
         required: 'Debe especificar el numero de finaciar',
         validate: value => !/[^0-9]/g.test(value) || 'Valor invalido'
        }),
        size: 'sm',
        className: 'text-center',
        autoComplete: 'off',
        defaultValue: 1,
        onFocus,
        onBlur,
        onKeyDown
       }}
      />
     </Card>
     <div className="px-0">
      <Flex className="fs--2 m-0">
       <h6 className="fs-3 ms-n1 my-0">{config.maxFinancing ?? 0}</h6>
       <div className="flex-1 position-relative">
        <h5 className="mb-0 text-success fs-1">max</h5>
        <span className="position-absolute top-50 start-0">/cuotas</span>
       </div>
      </Flex>
     </div>
    </Flex>
    <Flex wrap="wrap" className="fs--2 m'0">
     <Flex alignItems="center" wrap="wrap" className="position-relative flex-grow-1">
      <h5 className="m-0 fs--1 position-relative">
       <span className="fs-5">{(config.fncPercentage ?? 0) * 100}</span>
       <span className="align-top pt-3 position-absolute top-0 start-100 z-index-2 translate-middle">%</span>
      </h5>
      <div className="flex-1">
       <h6 className="m-0 ms-1">max</h6>
       <h6 className="m-0 p-0">.00</h6>
      </div>
      <SoftBadge pill bg="success" className="position-absolute top-100 start-0 z-index-2 translate-middle-y">
       {currency(config.totals - config.iniVal, true)} <FontAwesomeIcon icon="caret-up" />
      </SoftBadge>
     </Flex>
     <Card className="" style={{ maxWidth: '150px' }}>
      <Input
       type="text-floating"
       errors={errors}
       label="Financiacion"
       name="fncVal"
       placeholder="monto"
       //formGroupProps={{ className: '' }}
       formControlProps={{
        ...register('fncVal', {
         required: 'Debe especificar el monto de la financiacion',
         validate: value => !/[^0-9,.$ ]/g.test(value) || 'Caracteres invalidos'
        }),
        readOnly: true,
        autoComplete: 'off',
        //defaultValue: currency(config.totals - config.iniVal, true),
        onFocus,
        onBlur,
        onKeyDown,
        onChange
       }}
      />
     </Card>
    </Flex>
   </Card.Body>
  </Card>
 );
};

Financing.propTypes = {
 watch: PropTypes.func.isRequired,
 setValue: PropTypes.func.isRequired,
 register: PropTypes.func.isRequired,
 errors: PropTypes.object.isRequired,
 verifyFields: PropTypes.func.isRequired
};

export default Financing;
